// src/pages/user/Reviews.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { MdStar, MdStarBorder, MdEdit, MdDelete } from 'react-icons/md';
import UserMasterLayout from '../../../layout/useradmin/UserMasterLayout';
import '../../../assets/css/useradmin/reviews/Reviews.css';

const Reviews = () => {
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState('');

  const myReviews = [
    {
      id: 1,
      equipmentName: 'John Deere 5050D Tractor',
      bookingId: 'BK001',
      rating: 5,
      comment: 'Excellent tractor! Very powerful and fuel-efficient. The owner was very cooperative and the equipment was in great condition.',
      date: '2026-01-05',
      ownerResponse: null
    },
    {
      id: 2,
      equipmentName: 'Combine Harvester',
      bookingId: 'BK003',
      rating: 4,
      comment: 'Good equipment overall. Works perfectly for large-scale harvesting. Could be slightly better maintained but still very satisfied.',
      date: '2025-12-28',
      ownerResponse: 'Thank you for your feedback! We appreciate your business.'
    },
    {
      id: 3,
      equipmentName: 'Seed Drill 9-Tyne',
      bookingId: 'BK005',
      rating: 5,
      comment: 'Amazing service! The seed drill was in perfect condition and delivery was right on time. Highly recommended.',
      date: '2025-12-12',
      ownerResponse: null
    }
  ];

  const pendingReviews = [
    {
      id: 1,
      equipmentName: 'Rotavator 7ft',
      bookingId: 'BK002',
      completedDate: '2026-01-12'
    },
    {
      id: 2,
      equipmentName: 'Sprayer 400 Liter',
      bookingId: 'BK004',
      completedDate: '2026-01-08'
    }
  ];

  const handleWriteReview = (equipment) => {
    setSelectedEquipment(equipment);
    setRating(0);
    setReviewText('');
    setShowReviewModal(true);
  };

  const handleSubmitReview = () => {
    if (rating === 0) {
      alert('Please select a rating');
      return;
    }
    if (!reviewText.trim()) {
      alert('Please write a review');
      return;
    }
    alert('Review submitted successfully!');
    setShowReviewModal(false);
  };

  const handleEditReview = (reviewId) => {
    alert(`Edit review ${reviewId}`);
  };

  const handleDeleteReview = (reviewId) => {
    if (window.confirm('Are you sure you want to delete this review?')) {
      alert(`Review ${reviewId} deleted`);
    }
  };

  const renderStars = (count, interactive = false) => {
    return [...Array(5)].map((_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={index}
          onClick={() => interactive && setRating(starValue)}
          onMouseEnter={() => interactive && setHoverRating(starValue)}
          onMouseLeave={() => interactive && setHoverRating(0)}
          style={{ cursor: interactive ? 'pointer' : 'default' }}
        >
          {(interactive ? (hoverRating || rating) : count) >= starValue ? (
            <MdStar style={{ color: '#FDB714', fontSize: '24px' }} />
          ) : (
            <MdStarBorder style={{ color: '#e0e0e0', fontSize: '24px' }} />
          )}
        </span>
      );
    });
  };

  return (
    <UserMasterLayout>
      <Container fluid className="reviews-page">
        
        <div className="page-header">
          <h2>Reviews & Ratings</h2>
          <p>Share your experience with other users</p>
        </div>

        <Row>
          {/* My Reviews */}
          <Col lg={8} md={12}>
            <div className="reviews-section">
              <h3 className="section-title">My Reviews ({myReviews.length})</h3>
              
              <div className="reviews-list">
                {myReviews.map((review) => (
                  <div key={review.id} className="review-card">
                    <div className="review-header">
                      <div>
                        <h4>{review.equipmentName}</h4>
                        <span className="booking-id">Booking: {review.bookingId}</span>
                      </div>
                      <div className="review-actions">
                        <button 
                          className="icon-btn edit"
                          onClick={() => handleEditReview(review.id)}
                        >
                          <MdEdit />
                        </button>
                        <button 
                          className="icon-btn delete"
                          onClick={() => handleDeleteReview(review.id)}
                        >
                          <MdDelete />
                        </button>
                      </div>
                    </div>

                    <div className="rating-display">
                      {renderStars(review.rating)}
                      <span className="review-date">{review.date}</span>
                    </div>

                    <p className="review-comment">{review.comment}</p>

                    {review.ownerResponse && (
                      <div className="owner-response">
                        <strong>Owner Response:</strong>
                        <p>{review.ownerResponse}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* Pending Reviews */}
          <Col lg={4} md={12}>
            <div className="pending-section">
              <h3 className="section-title">Pending Reviews ({pendingReviews.length})</h3>
              
              <div className="pending-list">
                {pendingReviews.map((item) => (
                  <div key={item.id} className="pending-card">
                    <h5>{item.equipmentName}</h5>
                    <p className="completed-date">Completed: {item.completedDate}</p>
                    <button 
                      className="write-review-btn"
                      onClick={() => handleWriteReview(item)}
                    >
                      Write Review
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Rating Stats */}
            <div className="stats-section">
              <h3 className="section-title">Your Rating Stats</h3>
              <div className="stats-content">
                <div className="stat-item">
                  <span className="stat-label">Total Reviews:</span>
                  <span className="stat-value">{myReviews.length}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Average Rating:</span>
                  <span className="stat-value">
                    {(myReviews.reduce((sum, r) => sum + r.rating, 0) / myReviews.length).toFixed(1)} ⭐
                  </span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">5-Star Reviews:</span>
                  <span className="stat-value">{myReviews.filter(r => r.rating === 5).length}</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Review Modal */}
        <Modal show={showReviewModal} onHide={() => setShowReviewModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Write Review</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedEquipment && (
              <div className="review-form">
                <h5>{selectedEquipment.equipmentName}</h5>
                <p className="booking-info">Booking: {selectedEquipment.bookingId}</p>

                <div className="rating-input">
                  <label>Your Rating:</label>
                  <div className="stars-input">
                    {renderStars(rating, true)}
                  </div>
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Your Review:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Share your experience with this equipment..."
                    value={reviewText}
                    onChange={(e) => setReviewText(e.target.value)}
                  />
                </Form.Group>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="cancel-btn" onClick={() => setShowReviewModal(false)}>
              Cancel
            </button>
            <button className="submit-btn" onClick={handleSubmitReview}>
              Submit Review
            </button>
          </Modal.Footer>
        </Modal>

      </Container>
    </UserMasterLayout>
  );
};

export default Reviews;